import styled from "styled-components";
import { InlineDetailRow } from "../InlineDetailRow";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const FactsPanel = styled.section`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.base[3]};
  padding: ${({ theme }) => theme.spacing.base[3]};
  border: ${({ theme }) => theme.borders.width[1]}
    ${({ theme }) => theme.borders.style.solid}
    ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
  background: ${({ theme }) => theme.colors.background.primary};
`;

export const FactRow = styled(InlineDetailRow)`
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.base[3]};

  > span:first-child {
    flex: 1 1 auto;
    min-width: 0;
    ${typographyMixin("caption", 4)}
    overflow-wrap: anywhere;
  }

  > span:last-child {
    flex: 0 1 auto;
    min-width: 0;
    ${typographyMixin("body", 3)}
    justify-content: flex-end;
    overflow: visible;
    text-align: right;
    text-overflow: clip;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;

export const EmptyMessage = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;
